const getShortenedName = (displayName: string) => {
    const split = displayName.split(' ');
    const lastInitial = split[split.length - 1][0];
    return `${split[0]} ${lastInitial}.`;
};

export default getShortenedName;
